import { Routes } from '@angular/router';

import { authGuard } from '../shared/guards/auth.guard';
import { sistemaStatusGuard } from '../shared/guards/sistema-status.guard';

export const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('../protected-area/protected-area.routes').then(
        (m) => m.PROTECTED_ROUTES
      ),
    canActivate: [sistemaStatusGuard, authGuard],
    canActivateChild: [sistemaStatusGuard],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('../public-area/public-area.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'app',
  },
];
